
import { Component, inject, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Titledescription } from '../../../shared/components/titledescription/titledescription.component';
import { InputComponent } from '../../../shared/components/input/input.component';
import { CardComponent } from '../../../shared/components/card/card.component';
import { Table } from '../../../shared/components/table/table.component';
import { Button } from '../../../shared/components/button/button.component';
import { Form } from '../../../shared/components/form/form.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
// Importar servicios y constantes
import { TituloService } from '../../../core/titulo.service';
import { TITULOS_ACTIONS_CONSULTA, TITULOS_COLUMN_NAMES, TITULOS_COLUMN_NAMES_ASIGNAR } from '../../../constants/titulos.constants';
import { DEFAULT_PAGINATE_OPTIONS_LIST, defaultPaginateSelects, PaginateData, PaginateOptions } from '../../../utils/paginate.utils';
import { TituloInterface } from '../../../models/titulo.model';
import { BaseSelectService } from '../../../core/BaseSelect.service';
import { TITULOS_USUARIO_COLUMN_NAMES } from '../../../constants/titulos-usuario.constants';
import { TituloUsuarioService } from '../../../core/tituloUsuario.service';
import { TituloUsuarioInterface } from '../../../models/titulo-usuario.model';
import { AlertComponent } from '../../../shared/components/alert/alert.component';
// ...otros imports según tu lógica

@Component({
  selector: 'app-asignar-a-persona',
  imports: [
    CommonModule,
    Titledescription,
    InputComponent,
    CardComponent,
    Table,
    Button,
    Form,
    MatProgressSpinnerModule,
    MatIconModule,
    MatTableModule,
    MatListModule,
    MatDividerModule,
    MatExpansionModule,
    MatCardModule
  ],
  templateUrl: './asignar-a-persona.component.html',
  styleUrl: './asignar-a-persona.component.scss'
})
export class AsignarAPersonaComponent {
  dni!: number;
  isLoading = false;
  columnNamesTitulos = TITULOS_COLUMN_NAMES;
  columnNamesTitulosUsuario = TITULOS_USUARIO_COLUMN_NAMES;
  actionsTitulos = TITULOS_ACTIONS_CONSULTA;
  tituloService = inject(TituloService);
  tituloUsuarioService = inject(TituloUsuarioService);
  columnNamesTitulosAgregar = TITULOS_COLUMN_NAMES_ASIGNAR; // Puedes definir columnas específicas para agregar si es necesario
  // Variables para asignar títulos
  fieldsAddTitulos: any[] = [];
  dataTitulos: any[] = [];
  totalItemsAddTitulos = 0;
  dataAddTitulos: any = { total_items: 0 };
  titulosAddedActions: any[] = [];
  dataSelectNiveles: any[] = [];
  spinner = false;
  errorMessage = '';
  currentPaginateOptions: PaginateOptions = { skip: 0, take: 50 };
  titulosByDniData!: PaginateData<TituloInterface>;
  allTitulosData!: PaginateData<TituloInterface>;
  titulosUsuarioByDniData!: PaginateData<TituloUsuarioInterface>;
  defaultPaginateData = { ...DEFAULT_PAGINATE_OPTIONS_LIST };
  private alert = inject(AlertComponent);
  @ViewChild('titulosToAdd') tableTitulosToAdd!: Table<TituloInterface>
  getTitulosbyDni = (data: PaginateOptions , ignoreCache?:boolean) => {
    return this.tituloService.getByDni(data , this.dni, ignoreCache).subscribe({
      next: (data: PaginateData<TituloInterface>) => {
        data.data = [...data.data.filter((item: TituloInterface | null): item is TituloInterface => item !== null)];
        this.titulosByDniData = data;
      },
      error: () => {
      }
    });
  }
  getTitulosPortalByDni = (data: PaginateOptions , ignoreCache?:boolean) => {
    return this.tituloUsuarioService.getByDni(data , this.dni, ignoreCache).subscribe({
      next: (data: PaginateData<TituloUsuarioInterface>) => {
        data.data = [...data.data.filter((item: TituloUsuarioInterface | null): item is TituloUsuarioInterface => item !== null)];
        this.titulosUsuarioByDniData = data;
      },
      error: () => {
      }
    });
  }
  getAllTitulos = (data: PaginateOptions , ignoreCache?:boolean) => {
    return this.tituloService.getData(data,ignoreCache).subscribe((data: PaginateData<TituloInterface>) => {
      this.allTitulosData = { ...data };
    });
  }
  // Métodos
  onDniInput(value: number) {
    this.dni = value;
  }
  searchTitulos = () => {
    this.isLoading = true;
    this.getTitulosbyDni(this.defaultPaginateData, false);
    this.getTitulosPortalByDni(this.defaultPaginateData, false);
    this.getAllTitulos(this.defaultPaginateData);
  }
  downloadAllTitulosPDF() {
    // Lógica para descargar PDF
  }
  openModal(event: any) {
    // Lógica para abrir modal
  }
  filtrarPorDescripcion(options: any, ignoreCache: boolean) {
    // Lógica para filtrar
  }
  getClickedRows(data: PaginateData<TituloInterface>) {
    this.dataAddTitulos = {
      data: [...data.data],
      total_items: data.data.length
    };
  }
  deleteRow(event: any) {
    // Lógica para eliminar fila
  }
  submitForm() {
    this.alert.goBack = false; // Evitar que el alert navegue hacia atrás automáticamente
    this.alert.returnFocus = false; // Evitar que el alert intente devolver el foco automáticamente
    // Asignar todos los títulos seleccionados a la persona en un solo request
    if (!this.dni || !this.dataAddTitulos.data || this.dataAddTitulos.data.length === 0) {
      this.errorMessage = 'Debe ingresar un DNI y seleccionar al menos un título.';
      return;
    }
    this.spinner = true;
    const titulosIds = this.dataAddTitulos.data.map((titulo: any) => titulo.id);
    this.tituloService.asignarTitulosAPersona({ dni: this.dni, titulos: titulosIds }).toPromise()
      .then(() => {
        this.spinner = false;
        this.errorMessage = '';
        this.alert.openAlert('success', 'Títulos asignados correctamente');
        this.getTitulosbyDni(this.defaultPaginateData, true); // Refrescar títulos asignados
        this.clearAllTitulosAdded();
        this.scrollToTop();

      })
      .catch(() => {
        this.spinner = false;
        this.errorMessage = 'Error al asignar títulos.';
      });
  }
  clearAllTitulosAdded() {
    this.tableTitulosToAdd.clearAllSelectRow();
  }
  panelOpenState() {
    // Lógica para estado del panel
    return false;
  }
  selectedValueFromForm(event: any) {
    // Lógica para seleccionar valor del formulario
  }
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
